import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import styles from './LinearProgressBar.module.css';

export type LinearProgressBarProps = {
  className?: string;
};

export const LinearProgressBar: FunctionComponent<LinearProgressBarProps> = ({
  className,
}) => {
  return (
    <span
      className={cx(styles.root, className)}
      data-chromatic="ignore"
      role="progressbar"
    >
      <span className={cx(styles.bar, styles.bar1)} />
      <span className={cx(styles.bar, styles.bar2)} />
    </span>
  );
};
